module.exports = __webpack_public_path__ + "img/TechInfAttack1_ua.a1a52448.webp";